import m from "../../geodata/es2015/hongKongHigh";
window.am4geodata_hongKongHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/hongKongHigh.js
// module id = null
// module chunks = 